<template>
  <div class="forgot-password">
    <div class="forgot-password-form">
      <loading-logo ref="loadingLogo"/>

      <form v-if="!emailSent">
        <div class="info large">Reset Password</div>
        <div class="info">
          Enter your registered email address to reset your password.
        </div>
        <vi-input
          :autofocus="true"
          v-model="forgotPasswordForm.email"
          label="Email"
          type="text"
          :disabled="isLoading"
          placeholder=""
          @input="onInput"
        />
        <div class="error-msg" v-if="$v.forgotPasswordForm.email.$dirty && !$v.forgotPasswordForm.email.required">Email cannot be blank</div>
        <div class="error-msg" v-if="$v.forgotPasswordForm.email.$dirty && !$v.forgotPasswordForm.email.email">Enter valid email</div>
        <div class="login-link">
          Back to <span class="login-here" @click="logIn">login</span>
        </div>
        <div v-if="forgotPasswordErr" class="error">
          {{ forgotPasswordErr }}
        </div>
        <div class="actions">
          <vi-recaptcha-button
            label="RESET"
            :disabled="isLoading"
            @verify="forgotPassword"
          />
        </div>
      </form>
      <div v-else>
        <div class="info">
          A link to reset password has been sent to your registered email address.
        </div>
        <div class="info">
          Please click on the link in the mail to reset your password.
        </div>
        <div class="login-link">
          Back to <span class="login-here" @click="logIn">login</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import lottie from 'lottie-web';
  import ViInput from "../components/ui/ViInput";
  import ViButton from "../components/ui/ViButton";
  import LoadingLogo from "../components/LoadingLogo";
  import {required, email} from 'vuelidate/lib/validators'
  import ViRecaptchaButton from "../components/ui/ViRecaptchaButton";

  export default {
    name: "ForgotPassword",
    components: {ViRecaptchaButton, LoadingLogo, ViButton, ViInput},
    data() {
      return {
        forgotPasswordForm: {
          email: ''
        },
        isLoading: false,
        forgotPasswordErr: null,
        emailSent: false
      }
    },

    validations: {
      forgotPasswordForm: {
        email: {
          required,
          email
        }
      }
    },

    methods: {
      onInput() {
        this.forgotPasswordErr = null
      },
      forgotPassword(gRecaptcha) {

        this.$v.$touch();
        if (this.$v.$error) {
          return;
        }

        this.setIsLoading(true);
        this.$store
          .dispatch('auth/forgotPassword', {...this.forgotPasswordForm, gRecaptcha})
          .then(() => {
            this.setIsLoading(false);
            this.forgotPasswordForm = {
              email: ''
            }
            this.emailSent = true;
          })
          .catch(() => {
            this.setIsLoading(false);
            this.forgotPasswordErr = "This account is not registered with RemotePC Vision.";
          })
      },
      setIsLoading(isLoading) {
        this.isLoading = isLoading;
        this.$refs.loadingLogo.setLoading(isLoading);
      },
      logIn() {
        this.$router.push({
          name: "Login"
        })
      }
    },

  }
</script>

<style lang="scss">
  @import "ForgotPassword";
</style>
